// src/components/Header.jsx
import React, { useState, useEffect } from 'react';
import MenuIcon from '../images/menu-bar_10024326.svg';
import LogoImage from '../images/logo.png';
import CloseSvg from '../images/cancel_130887.svg';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(prev => !prev);

  useEffect(() => {
    const onKeyDown = e => {
      if (e.key === 'Escape' && menuOpen) setMenuOpen(false);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [menuOpen]);

  return (
    <div className="header-container">
      <header className="header">
        <a href="/" className="header-logo">
          <img src={LogoImage} alt="ICMO Summit Awards Logo" className="header-logo__img" />
          ICMO Summit Awards
        </a>
        <button
          className={`menu-toggle${menuOpen ? ' open' : ''}`}
          onClick={toggleMenu}
          aria-label="Menu"
        >
          <img src={MenuIcon} alt="Menu" className="icon" />
        </button>
      </header>

      <div
        className={`overlay${menuOpen ? ' overlay--visible' : ''}`}
        onClick={toggleMenu}
      />

      <aside className={`side-menu${menuOpen ? ' side-menu--open' : ''}`}>
        <button className="menu-close" onClick={toggleMenu} aria-label="Close menu">
          <img src={CloseSvg} alt="Close menu" className="menu-close__icon" />
        </button>

        <nav className="side-menu-nav">
          <ul>
            <li><a href="/" onClick={toggleMenu}>Главная</a></li>
            <li><a href="/jury" onClick={toggleMenu}>Жюри</a></li>
            <li><a href="/jurylist" onClick={toggleMenu}>Список жюри</a></li>
            <li><a href="/winners" onClick={toggleMenu}>Победители</a></li>
            <li><a href="/organizer" onClick={toggleMenu}>Организатор</a></li>
            <li><a href="/nominations" onClick={toggleMenu}>Номинации и критерии оценки</a></li>
            <li><a href="/terms" onClick={toggleMenu}>Положение</a></li>
            <li><a href="/articles" onClick={toggleMenu}>Статьи</a></li>
            <li><a href="#apply" onClick={toggleMenu}>Подать заявку</a></li>
          </ul>
        </nav>
      </aside>
    </div>
  );
}